(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promis-category-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const setupPromisCategoryMenu = (scope = document) => {
      scope.querySelectorAll('.promis-category-menu').forEach((menu) => {
        if (menu.dataset.promisCategoryReady === 'true') return;

        const track = menu.querySelector('[data-promis-category-track]');
        const list = menu.querySelector('[data-promis-category-list]');
        const previous = menu.querySelector('[data-promis-category-previous]');
        const next = menu.querySelector('[data-promis-category-next]');
        const current = menu.querySelector('[aria-current="page"]');
        if (!track || !list || !previous || !next) return;

        menu.dataset.promisCategoryReady = 'true';

        const updateControls = () => {
          const hasOverflow = list.scrollWidth > list.clientWidth + 2;
          const atStart = list.scrollLeft <= 2;
          const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
          track.classList.toggle('is-overflowing', hasOverflow);
          previous.disabled = !hasOverflow || atStart;
          next.disabled = !hasOverflow || atEnd;
        };

        const scrollCategories = (direction) => {
          const distance = Math.max(list.clientWidth * 0.72, 300);
          list.scrollBy({ left: distance * direction, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => scrollCategories(-1));
        next.addEventListener('click', () => scrollCategories(1));
        list.addEventListener('scroll', updateControls, { passive: true });

        requestAnimationFrame(() => {
          if (current && list.scrollWidth > list.clientWidth) {
            const left = current.offsetLeft - (list.clientWidth - current.clientWidth) / 2;
            list.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
          }
          updateControls();
        });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(updateControls);
          observer.observe(list);
        } else {
          window.addEventListener('resize', updateControls, { passive: true });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupPromisCategoryMenu());
    } else {
      setupPromisCategoryMenu();
    }

    document.addEventListener('shopify:section:load', (event) => setupPromisCategoryMenu(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promis-pdp-sticky"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('promis-pdp-sticky')) {
  customElements.define('promis-pdp-sticky', class extends HTMLElement {
    connectedCallback() {
      this.main = document.querySelector('product-info[id^="MainProduct"]');
      if (!this.main) return;
      this.action = this.querySelector('button');
      this.price = this.querySelector('.promis-pdp-sticky-price');
      this.onClick = () => {
        const button = this.main.querySelector('.f-main-product-form [name="add"]');
        if (!button || button.disabled) return;
        if (this.main.querySelector('input[name="selling_plan"], select[name="selling_plan"], input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')) {
          button.scrollIntoView({behavior:'smooth',block:'center'});
          button.focus({preventScroll:true});
          return;
        }
        button.click();
      };
      this.action.addEventListener('click', this.onClick);
      this.mobileQuery = window.matchMedia('(max-width:749px)');
      this.onMediaChange = () => this.updateVisibility();
      this.mobileQuery.addEventListener('change', this.onMediaChange);
      this.intersection = new IntersectionObserver(entries => {
        this.buttonAboveViewport = entries[0].boundingClientRect.bottom <= 0;
        this.updateVisibility();
      });
      this.scheduleSync = () => {
        if (this.syncFrame) return;
        this.syncFrame = requestAnimationFrame(() => {
          this.syncFrame = null;
          this.sync();
        });
      };
      this.observer = new MutationObserver(this.scheduleSync);
      this.observer.observe(this.main, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','value'],characterData:true});
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--promis-sticky-height', this.hidden ? '0px' : this.getBoundingClientRect().height + 'px');
      });
      this.resizeObserver.observe(this);
      this.sync();
    }
    updateVisibility() {
      this.hidden = !this.mainButton || !this.buttonAboveViewport || !this.mobileQuery.matches;
    }
    sync() {
      const button = this.main.querySelector('.f-main-product-form [name="add"]');
      const price = this.main.querySelector('[id^="Price-"]');
      if (button !== this.mainButton) {
        this.intersection.disconnect();
        this.mainButton = button;
        this.buttonAboveViewport = false;
        if (button) this.intersection.observe(button);
        this.updateVisibility();
      }
      if (!button) { this.hidden=true; return; }
      if (this.action.disabled !== button.disabled) this.action.disabled = button.disabled;
      const label = button.textContent.trim();
      if (this.action.textContent !== label) this.action.textContent = label;
      if (price && this.price.innerHTML !== price.innerHTML) this.price.innerHTML = price.innerHTML;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.resizeObserver?.disconnect();
      this.mobileQuery?.removeEventListener('change',this.onMediaChange);
      if (this.syncFrame) cancelAnimationFrame(this.syncFrame);
      document.documentElement.style.setProperty('--promis-sticky-height','0px');
      this.action?.removeEventListener('click',this.onClick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
